import React, { Component } from 'react';
import service from '../../core/service';
import { numberWithCommas, toFarsiNumber } from '../../core/utils';
import Cookies from 'js-cookie';
import { AppConstants } from '../../core/constants';
import axios from 'axios';

interface IProps {
  dispatch?: any,
}
interface IState {
  active?: number;
  loading?: boolean;
  data?: any
  options?: any,
  policyDetails?: any;
  identityInformation?: number;
  showMore: boolean;
  anchorEl: null | HTMLElement;
  open: any,
  selectedItem:number;
  beneficiary:number;
  beneficiaryList?:any;
  showDeathB?:boolean;
  showLifeB?:boolean;
  relationPersonList: any;
  base64Loading:boolean;
  pdf_type:string;

}

export class InsurancePolicyDetailsController extends Component<IProps, IState> {
  arrowRef:any;
  sliderRef1:any;
  sliderRef2:any;
  constructor(props: any) {
    super(props);

   this.sliderRef1 = React.createRef();
  }
  state: IState = {
    active: 1,
    relationPersonList: [],
    loading: false,
    anchorEl: null,
        open: false,
      selectedItem:0,
    data: {
      labels: [],
      family: "Peyda",


      datasets: [
        {

          label: "رشد پیش بینی شده (ریال)",
          data: [],
          fill: {

          },
          borderColor: "#00AA5B",
        },
        {

         
          data: [],
          label: " رشد تضمینی (ریال) ",
          // fill: false,
          borderColor: "#155a9e",
          fill: {

          },
          // backgroundColor:"gradient"
        }

      ],

    },
    options: {
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      plugins: {

        // tooltips: {
        //   // callbacks: {
        //   //   title: function(tooltipItem:any, data:any) {
        //   //     return data['labels'][tooltipItem[0]['index']];
        //   //   },
        //   //   label: function(tooltipItem:any, data:any) {
        //   //     return data['datasets'][0]['data'][tooltipItem['index']];
        //   //   },
        //   //   afterLabel: function(tooltipItem:any, data:any) {
        //   //     var dataset = data['datasets'][0];
        //   //     var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
        //   //     return '(' + percent + '%)';
        //   //   }
        //   // },
        //   backgroundColor: '#FFF',
        //   titleFontSize: 16,
        //   titleFontColor: '#0066ff',
        //   bodyFontColor: '#000',
        //   bodyFontSize: 14,
        //   displayColors: false
        // },
        tooltip: {
          backgroundColor: '#ffffff',
          titleFontSize: 16,
          boxHeight: "138px",
          bodyFontColor: '#000000',
          titleFontColor: '#000000',
          titleColor: '#000000',
          bodyFontSize: 14,
          bodyColor: "#000000",
          displayColors: false,
          borderColor: 'rgba(0, 0, 0, 0)',
          textAlign: "right",

          bodyFont: {
            family: "Peyda",

          },
          titleFont: {
            family: "Peyda",

          },
          rtl: true,

          callbacks: {
            // backgroundC
            borderColor: 'rgba(0, 0, 0, 0)',
            // titleFontSize: 16,
            // titleFontColor: '#0066ff',
            // bodyFontColor: '#000',
            // bodyFontSize: 14,
            // displayColors: false,

            labelColor: function () {
              return {
                borderColor: 'red',
                backgroundColor: 'blue',
                borderWidth: 2,
                borderDash: [2, 2],
                borderRadius: 2,
              };
            },
            labelTextColor: function () {
              // return '#00AA5B';
            },

            title: function (context: any) {
              let title = context[0]?.dataset?.label ;


              // if (context[0]?.parsed?.x !== null) {
              //     title += toFarsiNumber(numberWithCommas(context[0]?.parsed?.x));
              // }
              return title;
            },
            label: function (context: any) {


              // let label = context.dataset.label || '';
              let label = '';

              if (label) {
                label += '';
              }
              if (context?.parsed?.y !== null) {
                label += `  ${toFarsiNumber(numberWithCommas(context?.parsed?.y))} ریال`;
              }
              return label;
            },
          }
        },
        legend: {
          display: false,
          font: {
            family: "Peyda",
            lineHeight: 2,
            useBorderRadius: true,
            borderRadius: 20,

          },
        }
      },
      scales: {
        // to remove the labels
        x: {
          ticks: {
            font: {
              family: "Peyda",
              weight: 800,
            },
          },
          // to remove the x-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        // to remove the y-axis labels
        y: {
          ticks: {
            beginAtZero: true,
            callback: function (value: any) {
              return `${toFarsiNumber(numberWithCommas(value))}  `;
            },

            font: {
              family: "Peyda",
              weight: 800,
            },
          },
          // grid: {
          //   drawBorder: false,
          //   display: false,
          // },
          // to remove the y-axis grid

        },

      },
     
    },
    policyDetails: [],
    identityInformation: 1,
    showMore: false,
    beneficiary:1,
  beneficiaryList:[],
  showDeathB:false,
  showLifeB:false,
  base64Loading:false,
  pdf_type:""
  };


  getDetails = async () => {
    const {
    } = this.state;

    this.setState({ loading: true })
    try {
      const response = await service.Policies.details(window.location.pathname.split("/")[2]);
      if (response) {
        this.getRelationPerson()
        this.setState({
          policyDetails: response?.data?.data, loading: false,
          beneficiaryList: response?.data?.data?.life_benefit, })

          const guaranteed_reserve_array = []
          const forecast_redeem_value_array = []
          const year_array = []
for (var i = 0; i < response?.data?.data?.charts?.data.length;  i ++) {
          guaranteed_reserve_array.push(response?.data?.data?.charts?.data[i]?.guaranteed_reserve);
        }
        for (var i = 0; i < response?.data?.data?.charts?.data?.length;  i ++) {
          forecast_redeem_value_array.push(response?.data?.data?.charts?.data[i]?.forecast_redeem_value);
        }


        for (var i = 0; i < response?.data?.data?.charts?.data?.length; i ++) {
          year_array.push(toFarsiNumber(response?.data?.data?.charts?.data[i].year));
        }

        this.setState({
         

          data: {
            labels: year_array,
            family: "Peyda",


            datasets: [
              {

                label: "رشد پیش بینی شده (ریال)",
                data: forecast_redeem_value_array,
                fill: {

                },
                borderColor: "#00AA5B", 
              },
              {

                data: guaranteed_reserve_array, 
                label: " رشد تضمینی (ریال) " , 
                // fill: false,
                borderColor: "#155a9e", 
                fill: {

                },
                // backgroundColor:"gradient"
              }

            ]

          },




        })
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
   handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({anchorEl:event.currentTarget})
  };
   handleClose = () => {
    this.setState({anchorEl:null})
  };

  async getDownload(pdf_type:string) {
      this.setState({ base64Loading: true , pdf_type:pdf_type})
    const {
    } = this.state;
    try {
  
      const response = await axios.post(
        `${AppConstants.base_url_api}universalreport/`,
        {
        insurance_type:this.state.policyDetails?.policy?.insurance_type,
        policy_id:this.state.policyDetails?.policy?.idinsu,
        pdf_type:pdf_type
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:  `${Cookies.get('acto')}`,
          },
          responseType: "blob", 
      });
      if (response) {
      
  
      this.setState({ base64Loading: false })
      try {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    // this.setState({ base64Data: url })
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "report.pdf"); // نام فایل
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
      } catch (error) {
        console.error("خطایی رخ داد:", error   );
        this.setState({ base64Loading: false })
      } 
      }
    } catch (err: any) {
      // throw error;
    }
  };
  getRelationPerson = async () => {

    try {
      const response = await service.RelationPerson.relationPerson();
      if (response) {
        this.setState({ relationPersonList: response.data?.data })

      }
    } catch (error: any) {
      if (error && error.status) {
      }
    }
  };
}
export default InsurancePolicyDetailsController;
